/** 跨平台稳定的图表提取下载文件名（不含扩展名）最大长度 */
const MAX_BASENAME_LENGTH = 180;

const WINDOWS_FORBIDDEN_CHARS = /[\\/:*?"<>|]/g;

function padDatePart(value: number): string {
  return value.toString().padStart(2, "0");
}

export function getExtractChartFallbackBasename(date: Date | number = Date.now()): string {
  const targetDate = typeof date === "number" ? new Date(date) : date;
  const timestamp = [
    targetDate.getFullYear(),
    padDatePart(targetDate.getMonth() + 1),
    padDatePart(targetDate.getDate()),
    padDatePart(targetDate.getHours()),
    padDatePart(targetDate.getMinutes()),
    padDatePart(targetDate.getSeconds()),
  ].join("");

  return `Findin图表提取_${timestamp}`;
}

/** 将 caption 中的 Markdown 转为纯文本 */
export function stripExtractChartCaption(caption: string): string {
  return caption
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/`{1,3}([^`]+)`{1,3}/g, "$1")
    .replace(/[*_~>#]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

/** 清理非法字符、首尾空白，并截断过长标题（保留开头，末尾用 ...） */
export function sanitizeExtractChartBasename(
  title: string,
  maxLength = MAX_BASENAME_LENGTH,
): string {
  const plain = stripExtractChartCaption(title);
  if (!plain) return "";

  let sanitized = plain
    .replace(WINDOWS_FORBIDDEN_CHARS, "-")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");

  if (!sanitized) return "";

  if (sanitized.length <= maxLength) {
    return sanitized;
  }

  if (maxLength <= 3) {
    return sanitized.slice(0, maxLength);
  }

  return `${sanitized.slice(0, maxLength - 3)}...`;
}

export function getExtractChartDownloadFilename(
  caption: string,
  ext: string,
  fallbackBasename = getExtractChartFallbackBasename(),
): string {
  const basename = sanitizeExtractChartBasename(caption) || fallbackBasename;
  const normalizedExt = ext.replace(/^\./, "").toLowerCase() || "png";
  return `${basename}.${normalizedExt}`;
}

/** 在 ZIP 等多文件导出中避免重名，重复时追加 (2)、(3)… */
export function dedupeExtractChartBasename(
  basename: string,
  usedNames: Set<string>,
): string {
  if (!usedNames.has(basename)) {
    usedNames.add(basename);
    return basename;
  }

  let counter = 2;
  while (usedNames.has(`${basename} (${counter})`)) {
    counter += 1;
  }
  const deduped = `${basename} (${counter})`;
  usedNames.add(deduped);
  return deduped;
}

export function getImageExtFromBlob(blob: Blob): string {
  if (blob.type.includes("jpeg") || blob.type.includes("jpg")) {
    return "jpg";
  }
  if (blob.type.includes("png")) {
    return "png";
  }
  if (blob.type.includes("webp")) {
    return "webp";
  }
  if (blob.type.includes("gif")) {
    return "gif";
  }
  return "png";
}
